import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ClientApi, PositionTypeResource } from 'src/app/client-api.service';

@Injectable({
  providedIn: 'root'
})
export class PositionTypesService {

  private positionTypes = new BehaviorSubject<PositionTypeResource[]>([]);
  readonly positionTypes$ = this.positionTypes.asObservable();

  constructor(private apiClient: ClientApi) { }
 
  deletePositionType(id: number) {
    return this.apiClient.deletePositionType(id);
  }

  setPositionTypes() {
    this.getPositionTypes()      
        .subscribe(res => this.positionTypes.next(res));
  }

  getPositionTypes() {
    return this.apiClient.getPositionTypes();
  }               

  getPositionType(id: number) {
    return this.apiClient.getPositionType(id);
  }               

  putPositionType(positionTypeResource: PositionTypeResource)
  {
    positionTypeResource.name = positionTypeResource.name.toLocaleUpperCase();
    return this.apiClient.putPositionType(positionTypeResource);
  }
}
